import { useTranslation } from 'react-i18next';
import { ConcreteStructureTypes } from '../../../shared/constants/concrete-structure-types';
import Disclaimer from '../index';
import {
  DisclaimerContentWrapper,
  DisclaimerItalicsContentWrapper,
} from '../protected-sides-disclaimer/styles';
import BeamRequiredAxisTable from './beam-required-axis-table';
import { DisclaimerWrapper } from './styles';
import RequiredAxisTable from './table';

interface RequiredAxisDistanceDisclaimerProps {
  selectedStructureName: string;
}

export const RequiredAxisDistanceDisclaimer = ({
  selectedStructureName,
}: RequiredAxisDistanceDisclaimerProps) => {
  const { t } = useTranslation();

  const Table = () => {
    if (selectedStructureName == ConcreteStructureTypes.Beam) {
      return <BeamRequiredAxisTable />;
    } else return <RequiredAxisTable structureName={selectedStructureName} />;
  };

  return (
    <DisclaimerWrapper>
      <Disclaimer
        title={t('concrete.structuralElements.disclaimer.requiredAxisDistance')}
      >
        <DisclaimerContentWrapper>
          {t(
            `concrete.structuralElements.disclaimer.${selectedStructureName}.requiredAxisDistanceHeader`
          )}
        </DisclaimerContentWrapper>

        {<Table />}

        <DisclaimerItalicsContentWrapper className="italics">
          {t(
            `concrete.structuralElements.disclaimer.${selectedStructureName}.requiredAxisDistanceFooter`
          )}
        </DisclaimerItalicsContentWrapper>
      </Disclaimer>
    </DisclaimerWrapper>
  );
};
